/*
 * This file is generated by generators/load-tokens.js and should not be manually
 * modified as those changes will be overwritten when the generator runs again.
 */

import * as lodestarColors from "../system/lodestarColors";
import { colors as ursaColors } from "../system/ursaColors";

export const colorTokens = [
    {
        name: "aqua--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.aqua300,
        },
    },
    {
        name: "aqua--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.aqua50,
        },
    },
    {
        name: "aqua--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.aqua100,
        },
    },
    {
        name: "aqua--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.aqua75,
        },
    },
    {
        name: "aqua--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.aqua400,
        },
    },
    {
        name: "aqua--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.aqua800,
        },
    },
    {
        name: "aqua--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.aqua600,
        },
    },
    {
        name: "azure--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.azure400,
        },
    },
    {
        name: "azure--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.azure75,
        },
    },
    {
        name: "azure--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.azure200,
        },
    },
    {
        name: "azure--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.azure100,
        },
    },
    {
        name: "azure--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.azure400,
        },
    },
    {
        name: "azure--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.azure800,
        },
    },
    {
        name: "azure--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.azure700,
        },
    },
    {
        name: "blue--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.blue300,
        },
    },
    {
        name: "blue--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.blue50,
        },
    },
    {
        name: "blue--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.blue100,
        },
    },
    {
        name: "blue--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.blue75,
        },
    },
    {
        name: "blue--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.blue400,
        },
    },
    {
        name: "blue--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.blue800,
        },
    },
    {
        name: "blue--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.blue500,
        },
    },
    {
        name: "elevation--shadow-0",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "0px 3px 6px rgba(65, 80, 139, 0.12)",
        },
    },
    {
        name: "elevation--shadow-1",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "0px 2px 4px rgba(57, 61, 76, 0.16), 0px 6px 12px rgba(65, 80, 139, 0.12)",
        },
    },
    {
        name: "elevation--shadow-2",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "0px 4px 6px rgba(57, 61, 76, 0.12), 0px 6px 16px 6px rgba(65, 80, 139, 0.16)",
        },
    },
    {
        name: "elevation--shadow-3",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": "0px 2px 4px rgba(57, 61, 76, 0.12), 0px 12px 24px 8px rgba(65, 80, 139, 0.2)",
        },
    },
    {
        name: "focus-indicator--border-primary",
        description: "This is the main outer border for a focus ring",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.focus,
        },
    },
    {
        name: "focus-indicator--border-secondary",
        description:
            "This inner border provides more contrast between the focused element for scenarios where the element is on a background other than the work-surface",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral00,
        },
    },
    {
        name: "form-input--border--active",
        description:
            "Used for form elements that have an accompanying menu or popup. When that popup is open, this color is used for the associated control's border.",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.focus,
        },
    },
    {
        name: "form-input--border--error",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.red500,
        },
    },
    {
        name: "form-input--border--focus",
        description: "The border applied to form elements which are currently focused",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral200,
        },
    },
    {
        name: "form-input--border--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral400,
        },
    },
    {
        name: "form-input--border--readonly",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral75,
        },
    },
    {
        name: "form-input--border--rest",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral300,
        },
    },
    {
        name: "gold--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.gold600,
        },
    },
    {
        name: "gold--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.gold100,
        },
    },
    {
        name: "gold--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.gold300,
        },
    },
    {
        name: "gold--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.gold200,
        },
    },
    {
        name: "gold--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.gold500,
        },
    },
    {
        name: "gold--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.gold900,
        },
    },
    {
        name: "gold--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.gold800,
        },
    },
    {
        name: "green--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.green400,
        },
    },
    {
        name: "green--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.green50,
        },
    },
    {
        name: "green--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.green100,
        },
    },
    {
        name: "green--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.green75,
        },
    },
    {
        name: "green--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.green400,
        },
    },
    {
        name: "green--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.green800,
        },
    },
    {
        name: "green--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.green600,
        },
    },
    {
        name: "indigo--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.indigo300,
        },
    },
    {
        name: "indigo--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.indigo50,
        },
    },
    {
        name: "indigo--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.indigo100,
        },
    },
    {
        name: "indigo--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.indigo75,
        },
    },
    {
        name: "indigo--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.indigo400,
        },
    },
    {
        name: "indigo--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.indigo800,
        },
    },
    {
        name: "indigo--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.indigo500,
        },
    },
    {
        name: "mint--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.mint300,
        },
    },
    {
        name: "mint--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.mint50,
        },
    },
    {
        name: "mint--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.mint100,
        },
    },
    {
        name: "mint--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.mint75,
        },
    },
    {
        name: "mint--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.mint300,
        },
    },
    {
        name: "mint--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.mint800,
        },
    },
    {
        name: "mint--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.mint600,
        },
    },
    {
        name: "neutral--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral300,
        },
    },
    {
        name: "neutral--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral50,
        },
    },
    {
        name: "neutral--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral100,
        },
    },
    {
        name: "neutral--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral75,
        },
    },
    {
        name: "neutral--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral300,
        },
    },
    {
        name: "neutral--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral800,
        },
    },
    {
        name: "neutral--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral500,
        },
    },
    {
        name: "orange--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orange500,
        },
    },
    {
        name: "orange--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orange75,
        },
    },
    {
        name: "orange--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orange200,
        },
    },
    {
        name: "orange--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orange100,
        },
    },
    {
        name: "orange--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orange400,
        },
    },
    {
        name: "orange--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orange900,
        },
    },
    {
        name: "orange--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orange700,
        },
    },
    {
        name: "orchid--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orchid300,
        },
    },
    {
        name: "orchid--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orchid50,
        },
    },
    {
        name: "orchid--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orchid100,
        },
    },
    {
        name: "orchid--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orchid75,
        },
    },
    {
        name: "orchid--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orchid400,
        },
    },
    {
        name: "orchid--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orchid800,
        },
    },
    {
        name: "orchid--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.orchid600,
        },
    },
    {
        name: "pink--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.pink300,
        },
    },
    {
        name: "pink--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.pink50,
        },
    },
    {
        name: "pink--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.pink100,
        },
    },
    {
        name: "pink--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.pink75,
        },
    },
    {
        name: "pink--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.pink400,
        },
    },
    {
        name: "pink--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.pink800,
        },
    },
    {
        name: "pink--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.pink600,
        },
    },
    {
        name: "red--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.red300,
        },
    },
    {
        name: "red--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.red50,
        },
    },
    {
        name: "red--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.red100,
        },
    },
    {
        name: "red--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.red75,
        },
    },
    {
        name: "red--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.red400,
        },
    },
    {
        name: "red--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.red800,
        },
    },
    {
        name: "red--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.red600,
        },
    },
    {
        name: "rose--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.rose200,
        },
    },
    {
        name: "rose--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.rose50,
        },
    },
    {
        name: "rose--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.rose100,
        },
    },
    {
        name: "rose--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.rose75,
        },
    },
    {
        name: "rose--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.rose400,
        },
    },
    {
        name: "rose--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.rose800,
        },
    },
    {
        name: "rose--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.rose500,
        },
    },
    {
        name: "selection--border",
        description: "Default select border",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.blue500,
        },
    },
    {
        name: "selection--border-alt",
        description: "Card hover",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate300,
        },
    },
    {
        name: "selection--border-glow",
        description: "Selection outer/inner glow",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.blue75,
        },
    },
    {
        name: "selection--range--border",
        description: "Default select range/container border",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.blue400,
        },
    },
    {
        name: "semantic--error--background",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": lodestarColors.dangerLight20,
            "ursa-light": ursaColors.red50,
        },
    },
    {
        name: "semantic--error--background--active",
        description: "",
        value: {
            "lodestar-light": lodestarColors.dangerLight20,
            "ursa-light": ursaColors.red100,
        },
    },
    {
        name: "semantic--error--background--hover",
        description: "",
        value: {
            "lodestar-light": lodestarColors.dangerLight20,
            "ursa-light": ursaColors.red75,
        },
    },
    {
        name: "semantic--error--border",
        description: "Background color for elements that present critical information",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.red500,
        },
    },
    {
        name: "semantic--error--icon",
        description: "Used for icons",
        value: {
            "lodestar-light": lodestarColors.danger,
            "ursa-light": ursaColors.red600,
        },
    },
    {
        name: "semantic--error--text",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": lodestarColors.dangerDark30,
            "ursa-light": ursaColors.red800,
        },
    },
    {
        name: "semantic--error--text-inline",
        description: "Used for input validation",
        value: {
            "lodestar-light": lodestarColors.dangerDark20,
            "ursa-light": ursaColors.red600,
        },
    },
    {
        name: "semantic--info--background",
        description: "Backgrounds for banners and toasts",
        value: {
            "lodestar-light": lodestarColors.infoLight20,
            "ursa-light": ursaColors.blue50,
        },
    },
    {
        name: "semantic--info--background--active",
        description: "",
        value: {
            "lodestar-light": lodestarColors.infoLight20,
            "ursa-light": ursaColors.blue100,
        },
    },
    {
        name: "semantic--info--background--hover",
        description: "",
        value: {
            "lodestar-light": lodestarColors.infoLight20,
            "ursa-light": ursaColors.blue75,
        },
    },
    {
        name: "semantic--info--border",
        description: "Background color for elements that inform the user of some information",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.azure500,
        },
    },
    {
        name: "semantic--info--icon",
        description: "Used for icons",
        value: {
            "lodestar-light": lodestarColors.info,
            "ursa-light": ursaColors.blue500,
        },
    },
    {
        name: "semantic--info--text",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": lodestarColors.infoDark30,
            "ursa-light": ursaColors.blue800,
        },
    },
    {
        name: "semantic--info--text-inline",
        description: "Used for input validation",
        value: {
            "lodestar-light": lodestarColors.infoDark20,
            "ursa-light": ursaColors.blue500,
        },
    },
    {
        name: "semantic--success--background",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": lodestarColors.successLight20,
            "ursa-light": ursaColors.green50,
        },
    },
    {
        name: "semantic--success--background--active",
        description: "",
        value: {
            "lodestar-light": lodestarColors.successLight20,
            "ursa-light": ursaColors.green100,
        },
    },
    {
        name: "semantic--success--background--hover",
        description: "",
        value: {
            "lodestar-light": lodestarColors.successLight20,
            "ursa-light": ursaColors.green75,
        },
    },
    {
        name: "semantic--success--border",
        description: "Background color for elements that present a favorable outcome",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.green500,
        },
    },
    {
        name: "semantic--success--icon",
        description: "Used for icons",
        value: {
            "lodestar-light": lodestarColors.success,
            "ursa-light": ursaColors.green600,
        },
    },
    {
        name: "semantic--success--text",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": lodestarColors.successDark30,
            "ursa-light": ursaColors.green800,
        },
    },
    {
        name: "semantic--success--text-inline",
        description: "Used for input validation",
        value: {
            "lodestar-light": lodestarColors.successDark20,
            "ursa-light": ursaColors.green600,
        },
    },
    {
        name: "semantic--warning--background",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": lodestarColors.warningLight20,
            "ursa-light": ursaColors.gold100,
        },
    },
    {
        name: "semantic--warning--background--active",
        description: "",
        value: {
            "lodestar-light": lodestarColors.warningLight20,
            "ursa-light": ursaColors.gold300,
        },
    },
    {
        name: "semantic--warning--background--hover",
        description: "",
        value: {
            "lodestar-light": lodestarColors.warningLight20,
            "ursa-light": ursaColors.gold200,
        },
    },
    {
        name: "semantic--warning--border",
        description: "Background color for elements that provide caution",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.gold500,
        },
    },
    {
        name: "semantic--warning--icon",
        description: "Used for icons",
        value: {
            "lodestar-light": lodestarColors.warning,
            "ursa-light": ursaColors.gold800,
        },
    },
    {
        name: "semantic--warning--text",
        description: "Used on light backgrounds like banners and toasts",
        value: {
            "lodestar-light": lodestarColors.warningDark30,
            "ursa-light": ursaColors.gold900,
        },
    },
    {
        name: "semantic--warning--text-inline",
        description: "Used for input validation",
        value: {
            "lodestar-light": lodestarColors.warningDark20,
            "ursa-light": ursaColors.gold800,
        },
    },
    {
        name: "slate--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate300,
        },
    },
    {
        name: "slate--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate50,
        },
    },
    {
        name: "slate--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate100,
        },
    },
    {
        name: "slate--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate75,
        },
    },
    {
        name: "slate--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate300,
        },
    },
    {
        name: "slate--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate800,
        },
    },
    {
        name: "slate--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate500,
        },
    },
    {
        name: "surface--canvas--background",
        description: "Default canvas surface background color",
        value: {
            "lodestar-light": lodestarColors.neutralLight40,
            "ursa-light": ursaColors.slate25,
        },
    },
    {
        name: "surface--canvas--border",
        description: "top of work surface line",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate50,
        },
    },
    {
        name: "surface--canvas--border-scroll",
        description: "Scroll border when scrolling below fixed areas like headers.",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate100,
        },
    },
    {
        name: "surface--canvas--divider",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate75,
        },
    },
    {
        name: "surface--canvas--text",
        description: "Default canvas surface text color",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate800,
        },
    },
    {
        name: "surface--work--background",
        description: "Default work surface background color",
        value: {
            "lodestar-light": lodestarColors.neutralLight40,
            "ursa-light": ursaColors.neutral00,
        },
    },
    {
        name: "surface--work--background--hint",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral25,
        },
    },
    {
        name: "surface--work--divider",
        description: "column header line",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral50,
        },
    },
    {
        name: "surface--work--divider-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral75,
        },
    },
    {
        name: "surface--work--divider-scroll",
        description: "scroll or column freeze line",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.slate50,
        },
    },
    {
        name: "surface--work--text",
        description: "Default work surface text color",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral800,
        },
    },
    {
        name: "surface--work--text--inactive",
        description: "Used for readonly form fields sometimes",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral400,
        },
    },
    {
        name: "surface--work--text--inactive-hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.neutral500,
        },
    },
    {
        name: "teal--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.teal400,
        },
    },
    {
        name: "teal--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.teal50,
        },
    },
    {
        name: "teal--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.teal100,
        },
    },
    {
        name: "teal--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.teal75,
        },
    },
    {
        name: "teal--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.teal300,
        },
    },
    {
        name: "teal--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.teal800,
        },
    },
    {
        name: "teal--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.teal600,
        },
    },
    {
        name: "violet--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.violet300,
        },
    },
    {
        name: "violet--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.violet50,
        },
    },
    {
        name: "violet--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.violet100,
        },
    },
    {
        name: "violet--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.violet75,
        },
    },
    {
        name: "violet--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.violet400,
        },
    },
    {
        name: "violet--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.violet800,
        },
    },
    {
        name: "violet--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.violet500,
        },
    },
    {
        name: "yellow--background",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.yellow600,
        },
    },
    {
        name: "yellow--background-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.yellow100,
        },
    },
    {
        name: "yellow--background-alt--active",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.yellow300,
        },
    },
    {
        name: "yellow--background-alt--hover",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.yellow200,
        },
    },
    {
        name: "yellow--base",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.yellow500,
        },
    },
    {
        name: "yellow--text",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.yellow900,
        },
    },
    {
        name: "yellow--text-alt",
        description: "",
        value: {
            "lodestar-light": "",
            "ursa-light": ursaColors.yellow800,
        },
    },
] as const;
